export const stringNormalize = (text: string): string => {
  return text
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/gu, '')
    .toLocaleLowerCase();
};
